import React from 'react';
import { Table } from 'react-bootstrap';
import ParticipationsTableRow from './ParticipationsTableRow.jsx';

const ParticipationsTable = ({
  typeParticipating,
  title,
  initiative,
  initiativeParticipations,
  isPreview,
  survey,
  query,
  handleClickViewRespondentAnswers,
}) => {
  const renderParticipations = (data, depth = 0) => {
    // For supervisors only.
    // Supervisors' children are not real children. only for nice rendering,
    // and has no relation to children of participants
    return data.map((item) => (
      <React.Fragment key={`${item.id}${item.participantId}`}>
        <ParticipationsTableRow
          isPreview={isPreview}
          initiative={initiative}
          initiativeParticipation={item}
          handleClickViewRespondentAnswers={handleClickViewRespondentAnswers}
          survey={survey}
          query={query}
          depth={depth}
          typeParticipating={typeParticipating}
        />
        {item.children && renderParticipations(item.children, depth + 1)}
      </React.Fragment>
    ));
  };

  return (
    <Table condensed hover>
      <thead>
        <tr>
          <th>{title}</th>
          <th>Status</th>
          <th>
            <div className="flex flex-end">Actions</div>
          </th>
        </tr>
      </thead>
      <tbody>
        {initiativeParticipations.length ? (
          renderParticipations(initiativeParticipations)
        ) : (
          <tr>
            <td />
            <td>
              <p className="text-muted text-center m-b-0">
                There are no results matching your filters
              </p>
            </td>
            <td />
          </tr>
        )}
      </tbody>
    </Table>
  );
};

export default ParticipationsTable;
